export default "__VITE_ASSET__DpjkuxUo__"